// Frontend mirror of functions/constants/platformServices.js
// Defines gaming service accounts and their hardware platform mappings.

export const PLATFORM_SERVICES = {
  psn: {
    id: 'psn',
    displayName: 'PlayStation Network',
    shortName: 'PSN',
    icon: 'logo-playstation',       // Ionicons
    iconFamily: 'Ionicons',
    hardwarePlatforms: ['PS4', 'PS5'],
    accountNameLabel: 'PSN ID (Online ID)',
    accountNameHint: 'Your PlayStation Network Online ID',
    minLength: 3,
    maxLength: 16,
    color: '#003087',
  },
  xbox: {
    id: 'xbox',
    displayName: 'Xbox Live / Game Pass',
    shortName: 'Xbox Live',
    icon: 'logo-xbox',             // Ionicons
    iconFamily: 'Ionicons',
    hardwarePlatforms: ['Xbox Series X|S', 'Xbox One'],
    accountNameLabel: 'Gamertag',
    accountNameHint: 'Your Xbox Gamertag',
    minLength: 1,
    maxLength: 15,
    color: '#107C10',
  },
  steam: {
    id: 'steam',
    displayName: 'Steam',
    shortName: 'Steam',
    icon: 'logo-steam',            // Ionicons
    iconFamily: 'Ionicons',
    hardwarePlatforms: ['PC', 'macOS'],
    accountNameLabel: 'Steam Profile Name',
    accountNameHint: 'Your Steam display name',
    minLength: 2,
    maxLength: 32,
    color: '#1B2838',
  },
  epic: {
    id: 'epic',
    displayName: 'Epic Games',
    shortName: 'Epic',
    icon: 'gamepad-variant-outline', // MaterialCommunityIcons
    iconFamily: 'MaterialCommunityIcons',
    hardwarePlatforms: ['PC', 'macOS'],
    accountNameLabel: 'Epic Display Name',
    accountNameHint: 'Your Epic Games display name',
    minLength: 3,
    maxLength: 32,
    color: '#313131',
  },
  battlenet: {
    id: 'battlenet',
    displayName: 'Battle.net',
    shortName: 'Battle.net',
    icon: 'sword-cross',           // MaterialCommunityIcons
    iconFamily: 'MaterialCommunityIcons',
    hardwarePlatforms: ['PC'],
    accountNameLabel: 'BattleTag',
    accountNameHint: 'e.g., Player#1234',
    minLength: 3,
    maxLength: 32,
    color: '#148EFF',
  },
  ea: {
    id: 'ea',
    displayName: 'EA',
    shortName: 'EA',
    icon: 'shield-game',           // MaterialCommunityIcons (closest)
    iconFamily: 'MaterialCommunityIcons',
    hardwarePlatforms: ['PC', 'PS4', 'PS5', 'Xbox Series X|S', 'Xbox One'],
    accountNameLabel: 'EA ID',
    accountNameHint: 'Your EA account name',
    minLength: 3,
    maxLength: 32,
    color: '#FF4747',
  },
  riot: {
    id: 'riot',
    displayName: 'Riot Games',
    shortName: 'Riot',
    icon: 'shield-half-full',      // MaterialCommunityIcons
    iconFamily: 'MaterialCommunityIcons',
    hardwarePlatforms: ['PC'],
    accountNameLabel: 'Riot ID',
    accountNameHint: 'e.g., Player#NA1',
    minLength: 3,
    maxLength: 32,
    color: '#D32936',
  },
  ubisoft: {
    id: 'ubisoft',
    displayName: 'Ubisoft Connect',
    shortName: 'Ubisoft',
    icon: 'infinity',              // MaterialCommunityIcons
    iconFamily: 'MaterialCommunityIcons',
    hardwarePlatforms: ['PC', 'PS4', 'PS5', 'Xbox Series X|S', 'Xbox One'],
    accountNameLabel: 'Ubisoft Username',
    accountNameHint: 'Your Ubisoft Connect username',
    minLength: 3,
    maxLength: 32,
    color: '#0070FF',
  },
  activision: {
    id: 'activision',
    displayName: 'Activision',
    shortName: 'Activision',
    icon: 'target',                // MaterialCommunityIcons
    iconFamily: 'MaterialCommunityIcons',
    hardwarePlatforms: ['PC', 'PS4', 'PS5', 'Xbox Series X|S', 'Xbox One'],
    accountNameLabel: 'Activision ID',
    accountNameHint: 'e.g., Player#1234567',
    minLength: 3,
    maxLength: 32,
    color: '#FFFFFF',
  },
  nintendo: {
    id: 'nintendo',
    displayName: 'Nintendo Switch Online',
    shortName: 'Nintendo',
    icon: 'game-controller',       // Ionicons
    iconFamily: 'Ionicons',
    hardwarePlatforms: ['Nintendo Switch'],
    accountNameLabel: 'Nintendo Account Name',
    accountNameHint: 'Your Nintendo account name',
    minLength: 1,
    maxLength: 10,
    color: '#E60012',
  },
  rockstar: {
    id: 'rockstar',
    displayName: 'Rockstar Social Club',
    shortName: 'Rockstar',
    icon: 'star-circle',           // MaterialCommunityIcons
    iconFamily: 'MaterialCommunityIcons',
    hardwarePlatforms: ['PC', 'PS4', 'PS5', 'Xbox Series X|S', 'Xbox One'],
    accountNameLabel: 'Social Club Nickname',
    accountNameHint: 'Your Rockstar Social Club nickname',
    minLength: 3,
    maxLength: 32,
    color: '#FCAF17',
  },
};

/**
 * Get all gaming services that apply to a given hardware platform.
 */
export function getServicesForHardwarePlatform(hardwarePlatform) {
  return Object.values(PLATFORM_SERVICES).filter(
    svc => svc.hardwarePlatforms.includes(hardwarePlatform)
  );
}

/**
 * Games that always use a specific gaming service for identity.
 */
export const GAME_SERVICE_OVERRIDES = {
  'cod': 'activision',
  'val': 'riot',
  '2xk': 'riot',
  'lol': 'riot',
  'ow2': 'battlenet',
  'apl': 'ea',
  'mdn': 'ea',
  'rb6': 'ubisoft',
  'gt7': 'psn',
  'irc': 'steam',
};
